













import {Component, Prop, Vue} from "vue-property-decorator";
import {Notification} from "@/interfaces/entity";
import {NotificationStore} from "@/modules/notifications/store";

@Component({
    name: "NotificationCustomerTableAction"
})
export default class extends Vue {
    @Prop({required: true, type: Number})
    readonly id!: number;

    get notification(): Notification {
        return NotificationStore.data[this.id];
    }

    set notification(value: Notification) {
        NotificationStore.data[this.id] = value;
    }

    async onConfirm() {
        try {
            await NotificationStore.deleteNotification(this.id);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa thông báo thành công"
            });
        } catch (e) {
            console.log(e);
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa thông báo thất bại"
            });
        }
    }
}
